export default {
  modals: {
    delete_payment_method: {
      title: 'Er du sikker på, at du vil fjerne denne betalingsmetode?',
    },
  },
  buttons: {
    confirm: 'Bekræft',
    cancel: 'Annuller',
  },
  toasts: {
    failed_to_delete_payment_method: 'Betalingsmetoden kunne ikke slettes',
    payment_method_deleted: 'Betalingsmetoden er slettet',
  },
};
